import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import React from 'react';
import { Demande } from '../../../../Models/Demande/DemandeModels';
import dayjs from 'dayjs';
import { Flux } from '../../../../Models/Message/MessageModels';

export interface DialogMessagesCommandesCampagneProps{
    open: boolean,
    onClose: () => void,
    codeCampagneDialog:string,
    nomCampagneDialog:string
    demandesDialog:Demande[],
    fluxes:Flux[]
}

export default function DialogMessagesCommandesCampagne(props:DialogMessagesCommandesCampagneProps){
    const {onClose, open, codeCampagneDialog, nomCampagneDialog, demandesDialog, fluxes}=props;

    const demandes1erFiltrage = demandesDialog.filter(dem=>dem.parametresCampagnes && dem.parametresCampagnes.campagne===codeCampagneDialog && dayjs(dem.parametresCampagnes.dateFin).isAfter(dayjs(dem.dateApplication))); //filtre les demandes de désac avec les demande d'activation
    const demands2ndFiltrage = demandes1erFiltrage.filter(demande=> !demandes1erFiltrage.find(dem=>dem.id!==demande.id && dem.parametresCampagnes && demande.parametresCampagnes
        && demande.fluxes.find(flux=>dem.fluxes.find(fluxDem=>fluxDem.id===flux.id))
        && dem.parametresCampagnes.campagne===demande.parametresCampagnes.campagne
        && dem.parametresCampagnes.intitule===demande.parametresCampagnes.intitule
        && dayjs(dem.dateDemande).isAfter(demande.dateDemande)
    ))

    return(
        <Dialog
            maxWidth='lg'
            open={open}
            onClose={onClose}
            disableEnforceFocus
        >
            <DialogTitle>{codeCampagneDialog+' - '+nomCampagneDialog}</DialogTitle>
            <DialogContent>
                <TableContainer sx={{maxHeight:300}}>
                    <Table stickyHeader size='small'>
                    <TableHead>
                        <TableRow>
                            <TableCell>Message</TableCell>
                            <TableCell>Début</TableCell>
                            <TableCell>Fin</TableCell>
                            {
                                demands2ndFiltrage.find(dem=>dem.parametresCampagnes && dem.parametresCampagnes.typeAchatMessageCataMidis) && <TableCell>Type de commande</TableCell>
                            }
                            <TableCell>Flux</TableCell>
                        </TableRow>
                    </TableHead>
                    {
                        demands2ndFiltrage.map((demande, index)=>(
                        <TableBody key={index}>
                            <TableCell>{demande.parametresCampagnes?.intitule}</TableCell>
                            <TableCell>{dayjs(demande.parametresCampagnes?.dateDebut).format('DD/MM/YYYY')}</TableCell>
                            <TableCell>{dayjs(demande.parametresCampagnes?.dateFin).format('DD/MM/YYYY')}</TableCell>
                            {
                                demands2ndFiltrage.find(dem=>dem.parametresCampagnes && dem.parametresCampagnes.typeAchatMessageCataMidis) && <TableCell>{demande.parametresCampagnes?.typeAchatMessageCataMidis}</TableCell>
                            }
                            <TableCell>
                                {demande.fluxes.map(fluxDemande=>{
                                    let flux = fluxes.find(flux=>flux['@id']===fluxDemande['@id']);
                                    if(flux)return flux.nom+", "
                                    return fluxDemande.nom
                                })}
                            </TableCell>
                        </TableBody>
                        ))
                    }
                    </Table>
                </TableContainer>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Fermer</Button>
            </DialogActions>
        </Dialog>
    )
}